import StoreIndex from '@/Libs/Pages/Panel/Store/StoreIndex.vue'
import StoreDetail from '@/Libs/Pages/Panel/Store/StoreDetail.vue'
import BranchIndex from '@/Libs/Pages/Panel/Branch/BranchIndex.vue'
import BranchDetail from '@/Libs/Pages/Panel/Branch/BranchDetail.vue'
import OpenHourIndex from '@/Libs/Pages/Panel/OpenHour/OpenHourIndex.vue'
import SpecialDayIndex from '@/Libs/Pages/Panel/SpecialDay/SpecialDayIndex.vue'
import RoomDetail from '@/Libs/Pages/Panel/Room/RoomDetail.vue'
import RoomIndex from '@/Libs/Pages/Panel/Room/RoomIndex.vue'
import EmployeeForm from '@/Libs/Pages/Panel/Employee/EmployeeForm.vue'
import EmployeeIndex from '@/Libs/Pages/Panel/Employee/EmployeeIndex.vue'
import StuffIndex from '@/Libs/Pages/Panel/Stuff/StuffIndex.vue'

export default [
    {
        name: 'store',
        path: '/store',
        component: StoreIndex,
        meta: {
            title: 'store.title.list',
            permission: 'store_list'
        },
    },
    {
        name: 'store-detail',
        path: '/store/detail/:id',
        component: StoreDetail,
        meta: {
            title: 'store.title.detail',
            permission: 'store_show'
        },
    },
    {
        name: 'branch',
        path: '/branch',
        component: BranchIndex,
        meta: {
            title: 'branch.title.list',
            permission: 'branch_list'
        },
    },
    {
        name: 'branch-detail',
        path: '/branch/detail/:id',
        component: BranchDetail,
        meta: {
            title: 'branch.title.detail',
            permission: 'branch_show'
        },
    },
    {
        name: 'open-hour',
        path: '/open-hour',
        component: OpenHourIndex,
        meta: {
            title: 'open_hour.title.list',
            permission: 'open_hour_list'
        },
    },
    {
        name: 'special-day',
        path: '/special-day',
        component: SpecialDayIndex,
        meta: {
            title: 'special_day.title.list',
            permission: 'special_day_list'
        },
    },
    {
        name: 'room',
        path: '/room',
        component: RoomIndex,
        meta: {
            title: 'room.title.list',
            permission: 'room_list'
        },
    },
    {
        name: 'room-detail',
        path: '/room/detail/:id',
        component: RoomDetail,
        meta: {
            title: 'room.title.detail',
            permission: 'room_show'
        },
    },
    {
        name: 'stuff',
        path: '/stuff',
        component: StuffIndex,
        meta: {
            title: 'stuff.title.list',
            permission: 'stuff_list'
        },
    },
    {
        name: 'employee',
        path: '/employee',
        component: EmployeeIndex,
        meta: {
            title: 'employee.title.list',
            permission: 'employee_list'
        },
    },
    {
        name: 'employee-create',
        path: '/employee/create',
        component: EmployeeForm,
        meta: {
            title: 'employee.title.create',
            permission: 'employee_create'
        },
    },
    {
        name: 'employee-detail',
        path: '/employee/detail/:id',
        component: EmployeeForm,
        meta: {
            title: 'employee.title.detail',
            permission: 'employee_show'
        },
    },
];